import AutoReporting from "./AutoReporting";
import './autoReporting.scss';

export default AutoReporting;